import { observer } from 'mobx-react';
import { PublicNameProgramFamilyShareUrl } from '../../../../../../Types';
import InviteParticipantStore from '../../../InviteParticipantModal/Store';
import Body from './Body';

interface Props {
  programFamilyShareUrls: PublicNameProgramFamilyShareUrl[];
  inviteParticipantStore: InviteParticipantStore;
}

function sortByShareUrlName(
  a: PublicNameProgramFamilyShareUrl,
  b: PublicNameProgramFamilyShareUrl,
) {
  return a.name.text.localeCompare(b.name.text);
}

function LinkRow({ programFamilyShareUrls, inviteParticipantStore }: Props) {
  return [...programFamilyShareUrls]
    .sort(sortByShareUrlName)
    .map((programFamilyShareUrl) => (
      <Body
        programFamilyShareUrl={programFamilyShareUrl}
        key={programFamilyShareUrl.shareUrl.payload.id}
        inviteParticipantStore={inviteParticipantStore}
      />
    ));
}

export default observer(LinkRow);
